exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".modal-xs-aggregator .modal-dialog {\n  width: 390px; }\n\n.modal-xs-aggregator #tab-scale-options {\n  display: none; }\n\n.modal-xs-aggregator #tab-time-options {\n  display: none; }\n", ""]);

